import React from 'react';
require('style/ConfigNoteEdit');

class ConfigNoteEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            developerMode: false,
            note: props.note        
        }
    }

    noteChanged = (e) => {
        this.setState({note:e.target.value});
    }

    savePublicNote = ()=>{
        this.props.handleNoteChanged(this.state.note);
    }

    render() {
        return <div className="ConfigNoteEditContainer" >
            <div className='itemDiv'>
                <div>Public Note:</div>
                <textarea onChange={this.noteChanged} value={this.state.note} className="textArea"/>
                <button type="button" onClick={this.savePublicNote} className='saveToDeviceBtn'>Save Note</button>
            </div>
        </div>
    }
}

export default ConfigNoteEdit;


// WEBPACK FOOTER //
// ./client/components/configNoteEdit.js